import React from 'react';
import { Link } from 'react-router-dom';
import './GetInvolved.css';

function GetInvolved() {
  const ways = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
      ),
      title: 'Donate',
      description: 'Your financial support directly enables our medical missions and helps us provide care to those in need.',
      action: 'Make a Donation',
      link: '/contact'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      title: 'Volunteer',
      description: 'Join our team of dedicated healthcare professionals and support staff on life-changing medical missions.',
      action: 'Join Our Team',
      link: '/contact'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 18a5 5 0 0 0-10 0"/>
          <line x1="12" y1="2" x2="12" y2="9"/>
          <path d="M4.22 10.22 12 18l7.78-7.78"/>
        </svg>
      ),
      title: 'Partner',
      description: 'Organizations and corporations can partner with us to amplify our impact and reach more communities.',
      action: 'Become a Partner',
      link: '/contact'
    }
  ];

  return (
    <section className="get-involved section">
      <div className="container">
        <div className="section-header">
          <span className="section-subtitle">Get Involved</span>
          <h2 className="section-title">Join Our Mission</h2>
          <p className="section-description">
            There are many ways you can help us bring quality medical care to 
            communities in need. Every contribution makes a difference.
          </p>
        </div>

        <div className="ways-grid">
          {ways.map((way, index) => (
            <div key={index} className="way-card card">
              <div className="way-icon">
                {way.icon}
              </div>
              <h3 className="way-title">{way.title}</h3>
              <p className="way-description">{way.description}</p>
              <Link to={way.link} className="way-link">
                {way.action}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </Link>
            </div>
          ))}
        </div>

        <div className="newsletter-section">
          <div className="newsletter-content">
            <div className="newsletter-text">
              <h3 className="newsletter-title">Stay Connected</h3>
              <p className="newsletter-description">
                Subscribe to our newsletter to receive updates about our missions, 
                success stories, and upcoming opportunities to get involved.
              </p>
            </div>
            <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
              <input 
                type="email" 
                placeholder="Enter your email address" 
                className="newsletter-input"
                required
              />
              <button type="submit" className="btn btn-accent">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GetInvolved;

